export default __webpack_public_path__ + "static/media/025-emu.21a445db.svg";